import { isIncomingOperatorMessage } from './isIncomingOperatorMessage'

/**
 * Resolve legacy / API sender device uuid used for chat bubble alignment.
 * @param {object} message
 * @returns {string|null}
 */
export function resolveMessageSenderDeviceUuid (message) {
  if (!message) return null
  const raw =
    message.senderDeviceId ??
    message.senderDevice?.id ??
    message.senderDevice?.uuidDevice ??
    null
  if (raw == null || raw === '') return null
  return String(raw)
}

/**
 * True when the message was sent from the web platform (operator/admin/agent) or automated system.
 * Legacy wire: uuid_device_sender = "operator" | "system".
 */
export function isOperatorOrSystemSender (message) {
  const id = resolveMessageSenderDeviceUuid(message)
  if (!id) return false
  const normalized = id.toLowerCase()
  return normalized === 'operator' || normalized === 'system'
}

/** @deprecated Use isOperatorOrSystemSender — kept for existing imports. */
export function isOperatorOutboundMessage (message, _profileId) {
  return isOperatorOrSystemSender(message)
}

/**
 * Legacy main-chat footer: ✓ / ✓✓ on platform-originated and device→operator rows.
 * Requires a persisted id (legacy _checkIfMessageSent).
 */
export function shouldShowMainChatReceiptTicks (message, profileId) {
  if (!message?.id || message.receiverChatGroupId) return false
  if (isOperatorOrSystemSender(message)) return true
  if (isIncomingOperatorMessage(message, profileId) && message.senderDeviceId) return true
  return false
}

/** Group thread footer: operator/system or current-user outbound rows with a persisted id. */
export function shouldShowGroupChatReceiptTicks (message, profileId) {
  if (!message?.id || !message.receiverChatGroupId) return false
  if (isOperatorOrSystemSender(message)) return true
  if (profileId && message.senderUserId === profileId) return true
  return false
}

/** Whether to render delivery/read ticks on the bubble footer. */
export function shouldShowMessageDeliveryStatus (message, profileId) {
  if (message?.receiverChatGroupId) {
    return shouldShowGroupChatReceiptTicks(message, profileId)
  }
  return shouldShowMainChatReceiptTicks(message, profileId)
}
